import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_ID;

const hasConsent = () => {
  try {
    return localStorage.getItem("edil_cookie_consent") === "accepted";
  } catch (e) {
    return false;
  }
};

function loadGtag() {
  if (window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false, anonymize_ip: true });
}

// Google Analytics 4 caricato SOLO dopo consenso esplicito (GDPR / Garante).
export default function GoogleAnalytics() {
  const location = useLocation();
  const [enabled, setEnabled] = useState(() => hasConsent());

  useEffect(() => {
    const onConsent = (e) => {
      const val = e?.detail ?? (typeof localStorage !== "undefined" ? localStorage.getItem("edil_cookie_consent") : null);
      if (val === "accepted") setEnabled(true);
    };
    window.addEventListener("cookie-consent-changed", onConsent);
    return () => window.removeEventListener("cookie-consent-changed", onConsent);
  }, []);

  useEffect(() => {
    if (!GA_ID || !enabled) return;
    loadGtag();
  }, [enabled]);

  useEffect(() => {
    if (!GA_ID || !enabled || !window.gtag) return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
    });
  }, [enabled, location.pathname, location.search]);

  return null;
}
